import { Component } from '@angular/core'
import { trigger, style, animate, transition } from '@angular/animations'
import { NewTransactionComponent } from './new-transaction/new-transaction.component';
@Component({
    selector: 'gd-transviewer',
    styleUrls: ['./Transaction.component.css'],
    template: ` <gd-new-transaction @fade></gd-new-transaction> `,
    animations: [
        trigger('fade', [
            transition('void => *', [
                style({ opacity: 0 }),
                animate(2000, style({ opacity: 1 })),
            ]),
            transition('* => void', [animate(1000, style({ opacity: 0 }))]),
        ]),
    ],
    imports: [NewTransactionComponent]
})
export class TransactionViewerComponent {}
